





































// @ is an alias to /src
import {Component, Mixins} from "vue-property-decorator";
import PartnerList from "@/components/partner/partnerList.vue";
import PartnerDetail from "@/components/partner/partnerDetail.vue";
import PartnerCreate from "@/components/partner/partnerCreate.vue";
import PartnerCooperate from "@/components/partner/partnerCooperate.vue";
import Authority from "@/common/mixins/authority";

@Component({
  name: "PartnerListPage",
  components: {
    PartnerList,
    PartnerDetail,
    PartnerCreate,
    PartnerCooperate,
  },
})
export default class PartnerListPage extends Mixins(Authority) {
  public showPartnerInfor() {
    (this.$refs.pDetail as PartnerDetail).show();
  }

  public createPartner() {
    (this.$refs.pCreate as PartnerCreate).show();
  }
  public showEditCooperate(cooperateIndex = null) {
    (this.$refs.pCooperate as PartnerCooperate).show("edit", cooperateIndex);
  }
  public showCreateCooperate() {
    (this.$refs.pCooperate as PartnerCooperate).show("create");
  }

  public refreshMcList() {
    (this.$refs.pList as PartnerList).partnerList();
  }
}
